import { defineComponent, computed, createBlock, openBlock, unref, withCtx, createVNode, mergeProps, renderSlot } from "vue";
import { cn } from "../../../../lib/utils.js";
import { u as useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogPortal.js";
import { _ as _sfc_main$2 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogOverlay.js";
import { _ as _sfc_main$3 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogContent.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(__props, { emit: __emit }) {
    const props = __props, emits = __emit, delegatedProps = computed(() => {
      const { class: _, ...delegated } = props;
      return delegated;
    }), forwarded = useForwardPropsEmits(delegatedProps, emits);
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), null, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$2), {
          "data-slot": "alert-dialog-overlay",
          class: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80"
        }),
        createVNode(unref(_sfc_main$3), mergeProps({ "data-slot": "alert-dialog-content" }, unref(forwarded), {
          class: unref(cn)(
            "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg",
            props.class
          )
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogContent.js.map
